import { createApp, h } from "vue"
import { VueQueryPlugin } from "@tanstack/vue-query"
import App from "./App.vue"
import router from "./router"
import ElementPlus from "element-plus"
import i18n from "./i18n.js"
import store from "@/store"
import { useUserStore } from "@/store/user-store"
import trackClick from "@/services/analytics/directives/track-click"
import sentryService from "@/services/sentry-service"
import registerModule from "@/module-register"
import "./styles/index.scss"
import "./styles/element/index.scss"

import registerLoginModule from "@/modules/login"
import registerEnrollmentModule from "@/modules/enrollment"
import registerEnrollmentNewModule from "@/modules/enrollment-new"
import registerHomeModule from "@/modules/home"
import registerInstructionsModule from "@/modules/instructions"
import registerSchedulingModule from "@/modules/scheduling"
import { DateTime, Settings } from "luxon"
import asclepiusConfig from "@common/config/asclepius-config"
import { serverUrl } from "@/config"

// Set shared library Asclepius Server URL
asclepiusConfig.setAsclepiusServerUrl(serverUrl)

const app = createApp({
  created() {
    useUserStore().init().then()
  },
  render: () => h(App)
})

// * Add Directives
app.directive("track-click", trackClick)

// * Add custom properties
app.config.globalProperties.$luxon = DateTime
app.config.globalProperties.$luxonSettings = Settings

// register modules
registerModule(registerLoginModule)
registerModule(registerEnrollmentModule)
registerModule(registerEnrollmentNewModule)
registerModule(registerHomeModule)
registerModule(registerInstructionsModule)
registerModule(registerSchedulingModule)

// * Init Sentry Service
sentryService.init(app)

// * Add libraries
app.use(VueQueryPlugin).use(i18n).use(router).use(store).use(ElementPlus)

app.mount("#app")
